<template>
	<nav>
        <div class="links">
			<header-account-component v-if="navAccountsVisible"></header-account-component>
			<div class="line"></div>
			<router-link v-if="canViewDashboard" to="/dashboard" class="link"><span class="fa fa-solar-system"></span>Dashboard<span class="fa fa-chevron-right pointer"></span></router-link>
			<router-link v-if="canManageInquiries && navCount('_inquiries') > 0" to="/inquiries" class="link"><span class="fa fa-satellite-dish"></span>Web Inquiries<span class="count">{{ navCount('_inquiries') }}</span></router-link>
			<div v-for="module in visibleModules" :key="`nav-module-${ module.id }`">
				<div v-if="module.is_external && module.is_nav_heading" class="nav-title-container">
					<div class="nav-title"><span class="fa" :class="module.icon"></span>{{  module.name }}</div>
					<div class="line"></div>
				</div>
				<router-link v-else :to="`${ module.url_path_prefix }${ module.slug }`" class="link">
					<span class="fa" :class="module.icon"></span>{{ module.name }}<span v-if="!module.is_external" class="count">{{ navCount(module.slug) }}</span>
				</router-link>
			</div>
		</div>
	</nav>
</template>

<script>

import { mapGetters, mapState } from 'vuex';

import HeaderAccountComponent from '../../HeaderAccountComponent';
import SwitchAccountMenu from '../../SwitchAccountMenu';
import canViewDashboard from '@/utils/can-view-dashboard';
import getVisibleModules from '@/utils/get-visible-modules';

export default {

	computed: {
		...mapGetters([ 'modules', 'navCounts', 'currentAccount', 'masterAccount' ]),

		...mapState({
			accountMenuOpen: state => state.layout.accountMenuOpen,
			navAccountsVisible: state => state.layout.navAccountsVisible,
		}),

		canViewDashboard() {
			return this.currentAccount.id && canViewDashboard(this.currentAccount);
		},

		visibleModules() {
			return getVisibleModules(this.modules, this.currentAccount);
		},

		canManageInquiries() {
			const access = this.currentAccount.access || false;
			if (!access) return false;
			if (access.access_type === 'BASIC') {
				const permissions = access.access_permissions.split(',').filter(Boolean);
				return permissions.indexOf('_inquiries') !== -1 || permissions.indexOf('inquiries') !== -1;
			}

			return true;
		},

	},

	methods: {

		navCount(slug) {
			return this.navCounts[ slug ] || 0;
		},

		closeAccountMenu() {
			this.$store.dispatch('closeAccountMenu');
		},

	},

	watch: {
		'$route': function() {
			this.$store.dispatch('closeAccountMenu');
		},
	},

	components: {
		HeaderAccountComponent,
	},

};

</script>
